__webpack_require__.p = "/wp-content/themes/your-theme-name/dist/";